<script>
	import { page } from '$app/state';
	import Icon from '$lib/Components/Layout/Icon/Icon.svelte';
	import { slide } from 'svelte/transition';

	let { showBanner } = $props();
	let href = '/pricing-change';
	let title = 'Prices increase 10% on July 1, secure current pricing today.';
</script>

{#if showBanner && page.url.pathname !== href}
	<div
		transition:slide
		class="
    full-width grid w-full place-content-center bg-indow-green py-3 text-white
  "
	>
		<a
			{href}
			class="
     m-0 flex w-full items-center justify-center gap-2 p-0 text-center
     font-medium text-balance text-white no-underline
   "
		>
			<span>{title}</span>
			<Icon name="arrowCircle" class="size-6" />
		</a>
	</div>
{/if}
